import React from 'react';

export function CombatTrackerMockup() {
  const combatants = [
    { name: 'Thalion', init: 22, hp: 45, maxHp: 45, type: 'player', active: true },
    { name: 'Goblin Chef', init: 18, hp: 12, maxHp: 15, type: 'enemy', active: false },
    { name: 'Elara', init: 15, hp: 38, maxHp: 52, type: 'player', active: false },
    { name: 'Orc Warlord', init: 12, hp: 68, maxHp: 90, type: 'enemy', active: false },
    { name: 'Finn', init: 8, hp: 28, maxHp: 28, type: 'player', active: false },
  ];

  return (
    <div className="landing-mockup-card">
      <div className="flex items-center justify-between mb-3 px-1">
        <span className="font-cinzel text-xs font-bold text-primary">Round 3</span>
        <div className="flex gap-1">
          <span className="text-[10px] px-2 py-0.5 rounded-full bg-green-500/20 text-green-400">Active</span>
        </div>
      </div>
      {combatants.map((c, i) => {
        const hpPct = (c.hp / c.maxHp) * 100;
        const hpColor = hpPct > 60 ? 'bg-green-500' : hpPct > 30 ? 'bg-yellow-500' : 'bg-red-500';
        return (
          <div key={i} className={`flex items-center gap-2 py-1.5 px-2 rounded-lg mb-1 text-xs transition-colors ${c.active ? 'bg-primary/15 ring-1 ring-primary/30' : 'hover:bg-white/5'}`}>
            <span className="font-mono font-bold w-5 text-center text-muted-foreground">{c.init}</span>
            <div className={`w-2 h-2 rounded-full ${c.type === 'player' ? 'bg-blue-400' : 'bg-red-400'}`} />
            <span className={`flex-1 truncate ${c.active ? 'text-foreground font-semibold' : 'text-muted-foreground'}`}>{c.name}</span>
            <div className="w-16 h-1.5 rounded-full bg-muted overflow-hidden">
              <div className={`h-full rounded-full ${hpColor} transition-all`} style={{ width: `${hpPct}%` }} />
            </div>
            <span className="text-[10px] text-muted-foreground w-10 text-right">{c.hp}/{c.maxHp}</span>
          </div>
        );
      })}
    </div>
  );
}
